import { Section, SectionParagraph, SectionTitle } from '@/components/shared/Content';
import { Flex } from '@lemonade-hq/cdk';
import parse from 'html-react-parser';
import type React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  .trustpilot-widget-slider {
    width: 100%;
  }
`;

const StyledSubtitle = styled(SectionParagraph)`
  max-width: 900px;
`;

export interface CompareReviewsProps {
  show: boolean;
  title: string;
  subtitle: string;
  darkBackground?: boolean;
}

export const CompareReviews: React.FC<CompareReviewsProps> = ({ show, title, subtitle, darkBackground }) => {
  return (
    <Section darkBackground={darkBackground} py={[40, 70]}>
      <GlobalStyle />
      <Flex flexDirection="column" gap="20px" px="20px" mb={['30px', '80px']}>
        <SectionTitle>{title}</SectionTitle>
        <StyledSubtitle>{parse(subtitle)}</StyledSubtitle>
      </Flex>

      <Flex width="100%">
        {show && (
          <div
            className="trustpilot-widget trustpilot-widget-slider"
            data-locale="en-US"
            data-template-id="54ad5defc6454f065c28af8b"
            data-businessunit-id="58c6e2b50000ff00059e674d"
            data-style-height="240px"
            data-style-width="100%"
            data-theme="light"
            data-tags="pet"
            data-stars="1,2,3,4,5"
            data-review-languages="en"
          >
            <a href="https://www.trustpilot.com/review/lemonade.com" target="_blank" rel="noreferrer noopener">
              Trustpilot
            </a>
          </div>
        )}
      </Flex>
    </Section>
  );
};
